<template>
<section>
  <b-form-group
    id="streetOrderGroup"
    label="Street:"
    label-for="streetOrderGroup"
  >
  <b-input-group>
    <b-input-group-prepend is-text>
      <i class='fb-icon'></i>
    </b-input-group-prepend>
    <b-form-input
      id="street"
      type="text"
      v-model="fields.address.street"
    />
    </b-input-group>
  </b-form-group>
  <b-form-group
    id="cityOrderGroup"
    label="City:"
    label-for="cityOrderGroup"
  >
  <b-input-group>
    <b-input-group-prepend is-text>
      <i class='fb-icon'></i>
    </b-input-group-prepend>
    <b-form-input
      id="city"
      type="text"
      v-model="fields.address.city"
    />
    </b-input-group>
  </b-form-group>
  <b-form-group
    id="zipOrderGroup"
    label="Zip Code:"
    label-for="zipOrderGroup"
  >
  <b-input-group>
    <b-input-group-prepend is-text>
      <i class='fb-icon'></i>
    </b-input-group-prepend>
    <b-form-input
      id="zip"
      type="text"
      v-model="fields.address.zip"
    />
    </b-input-group>
  </b-form-group>
  <b-form-group
    id="stateOrderGroup"
    label="State:"
    label-for="stateOrderGroup"
  >
  <b-input-group>
    <b-input-group-prepend is-text>
      <i class='fb-icon'></i>
    </b-input-group-prepend>
    <b-form-input
      id="state"
      type="text"
      v-model="fields.address.state"
    />
    </b-input-group>
  </b-form-group>
  <b-form-group
    id="countryOrderGroup"
    label="Country:"
    label-for="countryOrderGroup"
  >
  <b-input-group>
    <b-input-group-prepend is-text>
      <i class='fb-icon'></i>
    </b-input-group-prepend>
    <b-form-input
      id="country"
      type="text"
      v-model="fields.address.country"
    />
    </b-input-group>
  </b-form-group>
</section>
</template>

<script>
export default {
  props: {
    fields: { type: Object, default: {} },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/sales-order/order-forms/AddressDetails.vue